module.exports = __webpack_public_path__ + "img/product26ap.5f4eb33e.png";